import script from "./UserFavoritesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFavoritesView.vue?vue&type=script&setup=true&lang=ts"

import "./UserFavoritesView.vue?vue&type=style&index=0&id=1f611cec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f611cec"]])

export default __exports__